export const environment = {
  production: false,
  apiLocations: {
    cookieDomain: '.amatis.dev',
    cookieName: 'AmatisTeleHealth-dev',
    login: 'https://telehealth.amatis.dev/login',
    menu: 'https://telehealth.amatis.dev/dashboard',
    identity: '/identity/api/v1',
    patient: '/patient/api/v1',
    patientHub: '/patient-hub',
    customer: '/customer/api/v1',
    chat: '/chat/api/v1',
    notification: '/notification/api/v1',
    derm: 'https://dermalogic.amatis.dev',
    osas: 'https://osas.amatis.dev',
    diab: 'https://diabetes.amatis.dev',
    backOffice: 'https://backoffice.amatis.dev',
  },
};
